import { render, staticRenderFns } from "./Sequra.vue?vue&type=template&id=5a148808&name=sequra&"
import script from "./Sequra.vue?vue&type=script&lang=js&"
export * from "./Sequra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports